import React, { Component } from 'react';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class IntegerField extends Component {
  render() {
    let {
      intl,
      translation,
      input,
      required,
      label,
      disabled,
      placeholder,
      displayType,
      id,
      readOnly,
      meta: { touched, error, warning },
      type = 'number',
      allowNegative,
      min,
      max,
    } = this.props;
    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(
          placeholderObj.message,
          placeholderObj.params,
        );
      }
    }

    let pattern = '';

    if (type === 'text') {
      pattern = allowNegative ? '[-0-9]*' : '[0-9]*';
    }

    let showError = touched && error ? 'error' : '';

    if (displayType === 'inline') {
      return (
        <InlineField
          fieldType="renderInteger"
          content={input.value}
          label={label}
          id={id}
        />
      );
    }

    return (
      <div id={id} className={`${required && 'required'} field ${showError}`}>
        {label && <label>{label}</label>}
        <div>
          <input
            {...input}
            min={min}
            max={max}
            type={type}
            pattern={pattern}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
          />
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      </div>
    );
  }
}

export const INTEGER = (min) => {
  return (value) => {
    value = Number(value).toFixed(0);

    if (!value) {
      return value;
    }
    if (value >= min) {
      return Math.round(Number(value));
    }
    if (value < min) {
      return min;
    }
    if (value && /^\d+$/i.test(value)) {
      return value;
    }
    if (value && isNaN(Number(value))) {
      return null;
    }

    return Number(value);
  };
};

export const asInteger = (amount) => {
  return INTEGER()(amount);
};
